// extracted by mini-css-extract-plugin
export default {"variables":"\"../../variables.css\"","headerHeight":"85px","layoutGap":"24px","layout":"dashboardLayout_layout__sYrOV","content":"dashboardLayout_content__J2uW1"};